<template>
  <v-speed-dial v-model="fab" :bottom="false" :direction="direction" :open-on-hover="false" :right="false"
                :transition="transition">
  <template v-slot:activator>
    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.change_state')">
      <v-btn v-model="fab" :color="colorStates[state-1]" dark fab small v-on="on">
        <v-icon>{{ iconStates[state - 1] }}</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
    </Tooltip>
  </template>

    <Tooltip v-slot:default="{on}" :text="$t('states.completed')">
      <v-btn color="green" dark fab small @click="changeState(states.COMPLETED)" v-on="on">
        <v-icon>receipt</v-icon>
      </v-btn>
    </Tooltip>

    <Tooltip v-slot:default="{on}" :text="$t('states.saved')">
      <v-btn v-if="state==states.SAVED" color="indigo" dark fab small @click="changeState(states.SAVED)" v-on="on">
        <v-icon>save</v-icon>
      </v-btn>
    </Tooltip>

    <Tooltip v-slot:default="{on}" :text="$t('states.archived')">
      <v-btn color="red" dark fab small @click="changeState(states.ARCHIVED)" v-on="on">
        <v-icon>archive</v-icon>
      </v-btn>
    </Tooltip>
</v-speed-dial>
</template>

<script>
import states from '@/enums/states'
import Tooltip from "../common/Tooltip.vue"

export default {
  components: {Tooltip},
  props: {
    id: [String, Number],
    state: Number,
    direction: {
      type: String,
      default: () => "left"
    }
  },
  data() {
    return {
      fab: false,
      transition: 'slide-y-reverse-transition',
      states: states,
      iconStates: ["receipt", "save", "archive"],
      colorStates: ["green", "indigo", "red"]

    }
  },
  computed: {

  },
  methods: {
    changeState(state) {
      if (this.id === 0) {
        return this.$emit("stateChanged", state)
      }

      if (this.state == state) {
        return
      }

      this.$store.dispatch('updateStateForm', {
        schema_id: this.$route.params.schemaId,
        form_id: this.id,
        state
      })
        .then(() => {
          this.$store.commit('setSnack', {
            message: this.$t('form.update.success-message'),
            color: 'success'
          })
        })
        .catch(() => {
          this.$store.commit('setSnack', {
            message: this.$t('form.update.error-message'),
            color: 'danger'
          })
        })
    }
  }


}
</script>
